import {Modal, message} from "antd"
import RegisterPDF from "../../../Layouts/PDF/Register/RegisterPDF"
import { useCallback } from "react"
import CenterService from "../../../../services/CenterService"

export default function RegisterPermissionLetterCenter(props) {
    const {propsModal,propsOptions,propsCenter,propsIsUploadPDF,propsModalOption,propsDataUpdate}=props
    const propsRegister={
        registerPDF:(data)=>createPermissionLetterCenter(data),

    }
    const createPermissionLetterCenter=useCallback((data)=>{
        let document=data;
        const formData = new FormData();
        Object.entries(document).forEach(([key, value]) => {
            formData.append(key, value);
          });
          if(document.documentApprovalAttachment!==undefined){
            let blob = new Blob([document.documentApprovalAttachment.fileList[0].originFileObj] , { type: "application/pdf" });
            //objectUrl = URL.createObjectURL(blob);
            //console.log("objectUrl",objectUrl)
            formData.set("documentApprovalAttachment",blob,document.documentApprovalAttachment.fileList[0].originFileObj.name);
          }
          console.log("eneneneneen",propsModalOption)
       if(propsModalOption==="create"){
        CenterService.createDocumentApproval(formData,propsCenter.id,propsCenter.User.id).then((res)=>{
            if(res.data?.success){
                message.success("Se subio el archivo de forma correcta")
                propsIsUploadPDF(true)
            }else{
                message.error("Hubo un problema para subir el archivo")
            }
        })
       }
       else if(propsModalOption==="update"){
        CenterService.updateDocumentApproval(formData,propsCenter.id,propsCenter.User.id).then((res)=>{
            if(res.data?.success){
                message.success("Se actualizo el archivo de forma correcta")
                propsIsUploadPDF(true)
            }else{
                message.error("Hubo un problema para actualizar el archivo")
            }
        })
       }
    })
    return(
        <>
        <Modal
        {...propsModal}
        >
            <RegisterPDF 
            {...propsOptions}
            propsRegister={propsRegister}
            dataUpdate={propsDataUpdate}></RegisterPDF>
        </Modal>
        </>
    )
}